<header id="page-topbar" (window:scroll)="windowScroll()">
  <div class="layout-width">
      <div class="navbar-header">
          <div class="d-flex">
              <!-- LOGO -->
              <div class="navbar-brand-box horizontal-logo">
                  <a routerLink="/" class="logo logo-dark">
                      <span class="logo-sm">
                          <img src="assets/images/logo-sm.png" alt="" height="22">
                      </span>
                      <span class="logo-lg">
                          <img src="assets/images/logo-dark.png" alt="" height="22">
                      </span>
                  </a>

                  <a routerLink="/" class="logo logo-light">
                      <span class="logo-sm">
                          <img src="assets/images/logo-sm.png" alt="" height="22">
                      </span>
                      <span class="logo-lg">
                          <img src="assets/images/logo-light.png" alt="" height="22">
                      </span>
                  </a>
              </div>

              <button type="button" class="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger shadow-none" id="topnav-hamburger-icon" (click)="toggleMobileMenu($event)">
                  <span class="hamburger-icon">
                      <span></span>
                      <span></span>
                      <span></span>
                  </span>
              </button>

              <form class="app-search d-none d-md-inline-flex">
                  <div class="position-relative">
                      <input type="text" class="form-control" placeholder="{{ 'TOPBAR.BUSCAR' | translate }}" autocomplete="off" id="search-options" value="" (keyup)="Search()">
                      <span class="mdi mdi-magnify search-widget-icon"></span>
                      <span class="mdi mdi-close-circle search-widget-icon search-widget-icon-close d-none" id="search-close-options" (click)="closeBtn()"></span>
                  </div>
                  <div class="dropdown-menu dropdown-menu-lg" id="search-dropdown">
                      <ngx-simplebar style="max-height: 320px;">
                          <!-- item-->
                          <div class="dropdown-header">
                              <h6 class="text-overflow text-muted mb-0 text-uppercase">Recent Searches</h6>
                          </div>

                          <div class="dropdown-item bg-transparent text-wrap">
                              <a routerLink="/" class="btn btn-subtle-secondary btn-sm btn-rounded me-1">how to setup <i class="mdi mdi-magnify"></i></a>
                              <a routerLink="/" class="btn btn-subtle-secondary btn-sm btn-rounded">buttons <i class="mdi mdi-magnify"></i></a>
                          </div>
                          <!-- item-->
                          <div class="dropdown-header mt-2">
                              <h6 class="text-overflow text-muted mb-1 text-uppercase">Pages</h6>
                          </div>

                          <!-- item-->
                          <a href="javascript:void(0);" class="dropdown-item notify-item">
                              <i class="ri-bubble-chart-line align-middle fs-18 text-muted me-2"></i>
                              <span>Analytics Dashboard</span>
                          </a>

                          <!-- item-->
                          <a href="javascript:void(0);" class="dropdown-item notify-item">
                              <i class="ri-lifebuoy-line align-middle fs-18 text-muted me-2"></i>
                              <span>Help Center</span>
                          </a>

                          <!-- item-->
                          <a href="javascript:void(0);" class="dropdown-item notify-item">
                              <i class="ri-user-settings-line align-middle fs-18 text-muted me-2"></i>
                              <span>My account settings</span>
                          </a>

                          <!-- item-->
                          <div class="dropdown-header mt-2">
                              <h6 class="text-overflow text-muted mb-2 text-uppercase">Members</h6>
                          </div>

                          <div class="notification-list">
                              <!-- item -->
                              <a href="javascript:void(0);" class="dropdown-item notify-item py-2">
                                  <div class="d-flex">
                                      <img src="assets/images/users/48/avatar-2.jpg" class="me-3 rounded-circle avatar-xs" alt="user-pic">
                                      <div class="flex-1">
                                          <h6 class="m-0">Angela Bernier</h6>
                                          <span class="fs-11 mb-0 text-muted">Manager</span>
                                      </div>
                                  </div>
                              </a>
                              <!-- item -->
                              <a href="javascript:void(0);" class="dropdown-item notify-item py-2">
                                  <div class="d-flex">
                                      <img src="assets/images/users/avatar-3.jpg" class="me-3 rounded-circle avatar-xs" alt="user-pic">
                                      <div class="flex-1">
                                          <h6 class="m-0">David Grasso</h6>
                                          <span class="fs-11 mb-0 text-muted">Web Designer</span>
                                      </div>
                                  </div>
                              </a>
                              <!-- item -->
                              <a href="javascript:void(0);" class="dropdown-item notify-item py-2">
                                  <div class="d-flex">
                                      <img src="assets/images/users/avatar-5.jpg" class="me-3 rounded-circle avatar-xs" alt="user-pic">
                                      <div class="flex-1">
                                          <h6 class="m-0">Mike Bunch</h6>
                                          <span class="fs-11 mb-0 text-muted">React Developer</span>
                                      </div>
                                  </div>
                              </a>
                          </div>
                      </ngx-simplebar>

                      <div class="text-center pt-3 pb-1">
                          <a href="javascript:void(0);" class="btn btn-primary btn-sm">View All Results <i class="ri-arrow-right-line ms-1"></i></a>
                      </div>
                  </div>
              </form>
          </div>

          <div class="d-flex align-items-center">

              <div dropdown class="dropdown ms-1 topbar-head-dropdown header-item">
                  <button dropdownToggle type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle">
                      @if (flagvalue == undefined) {
                      <img id="header-lang-img" src="{{valueset}}" alt="Header Language" height="20" class="rounded">
                      }@else {
                      <img id="header-lang-img" src="{{flagvalue}}" alt="Header Language" height="20" class="rounded">
                      }
                  </button>
                  <div *dropdownMenu class="dropdown-menu dropdown-menu-end">

                      <!-- item-->
                      @for (item of listLang; track $index) {
                      <a href="javascript:void(0);" class="dropdown-item notify-item language py-2" (click)="setLanguage(item.text, item.lang, item.flag)">
                          <img src="{{item.flag}}" alt="user-image" class="me-2 rounded" height="18">
                          <span class="align-middle">{{item.text}}</span>
                      </a>
                  }
                  </div>
              </div>

              <div class="ms-1 header-item d-none d-sm-flex">
                  <button type="button" class="btn btn-icon btn-topbar btn-ghost-dark rounded-circle" data-toggle="fullscreen" (click)="fullscreen()">
                      <i class="bi bi-arrows-fullscreen fs-lg"></i>
                  </button>
              </div>

              <div dropdown container="body" class="dropdown topbar-head-dropdown ms-1 header-item">
                  <button dropdownToggle type="button" class="btn btn-icon btn-topbar btn-ghost-dark rounded-circle mode-layout">
                      <i class="bi bi-sun align-middle fs-3xl"></i>
                  </button>
                  <div *dropdownMenu class="dropdown-menu p-2 dropdown-menu-end" id="light-dark-mode">
                      <a href="javascript:void(0);" class="dropdown-item" (click)="changeMode('light')"><i class="bi bi-sun align-middle me-2"></i> {{ 'TOPBAR.TEMA_CLARO' | translate }}</a>
                      <a href="javascript:void(0);" class="dropdown-item" (click)="changeMode('dark')"><i class="bi bi-moon align-middle me-2"></i> {{ 'TOPBAR.TEMA_OSCURO' | translate }}</a>
                      <a href="javascript:void(0);" class="dropdown-item" (click)="changeMode('auto')"><i class="bi bi-moon-stars align-middle me-2"></i> {{ 'TOPBAR.TEMA_AUTO' | translate }}</a>
                  </div>
              </div>

              <div dropdown class="dropdown ms-sm-3 header-item topbar-user">
                  <button dropdownToggle type="button" class="btn shadow-none" id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <span class="d-flex align-items-center">
                          <div class="header-profile-user rounded-circle flex-shrink-0">
                              <span class="avatar-title rounded-circle bg-primary-subtle text-primary fw-semibold">{{ inicialesUsuario }}</span>
                          </div>
                          <span class="text-start ms-xl-2">
                              <span class="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{{nombreUsuario}}</span>
                              <span class="d-none d-xl-block ms-1 fs-sm user-name-sub-text">{{etiquetaRol}}</span>
                          </span>
                      </span>
                  </button>
                  <div *dropdownMenu class="dropdown-menu dropdown-menu-end">
                      <!-- item-->
                      <h6 class="dropdown-header">{{ 'TOPBAR.BIENVENIDA' | translate:{ nombre: nombreUsuario } }}</h6>
                      <a class="dropdown-item" routerLink="/"><i class="mdi mdi-account-circle text-muted fs-lg align-middle me-1"></i> <span class="align-middle"> {{ 'TOPBAR.PERFIL' | translate }}</span></a>
                      <a class="dropdown-item" routerLink="/auth/lockscreen"><i class="mdi mdi-lock text-muted fs-lg align-middle me-1"></i> <span class="align-middle"> {{ 'TOPBAR.PANTALLA_BLOQUEO' | translate }}</span></a>
                      <a class="dropdown-item" href="javascript: void(0);" (click)="logout()"><i class="mdi mdi-logout text-muted fs-lg align-middle me-1"></i> <span class="align-middle"> {{ 'TOPBAR.CERRAR_SESION' | translate }}</span></a>
                  </div>
              </div>
          </div>
      </div>
  </div>
</header>
